import gbAntSelectPagination from "./src/gb-ant-select-pagination.vue";
const gbAntSelectPaginationCompenet = function(Vue) {
  Vue.component(gbAntSelectPagination.name, gbAntSelectPagination);
};
export default gbAntSelectPaginationCompenet;
